import React from 'react';
import { useState } from 'react';
import banner from './assets/banner (1).png'
import aboutus from './assets/new about us.png'
import architecture from './assets/architecture.png'
import intelligence from './assets/business intelligence solutions.png'
import automation from './assets/business process automation.png'
import legacy from './assets/legacy modernization.png'
import mobile from './assets/mobile.png'
import contact from './assets/contact us.png'
import logo from './assets/newItechNemarran.png'
import axios from 'axios'

export const Home = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
   const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // Remove error as user types
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email format is invalid.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    }

    return newErrors;
  };
  const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = validate();

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
  } else {
    try {
      setLoading(true);

      const response = await axios.get(
        "http://54.152.42.27:44304/api/V1/Mail/Log",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }
      );

      console.log("API response:", response.data);
            const emailResponse = await axios.post(
        "http://54.152.42.27:44304/api/V1/Mail/SendEmail",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }
      );
      console.log("Send Email API response:", emailResponse.data);
      alert("Form submitted successfully!");

      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      alert("Failed to submit. Please try again.");
    } finally {
      setLoading(false);
    }
  }
};

  
  return (
    <div>
       {/*The navbar code starts here. */}

          <nav className="navbar navbar-expand-lg navbar-light bg-light navbarsticky">
  <div className="container-fluid">
    <a className="navbar-brand" href="#">
  <img 
    src={logo} 
    alt="iTechNemaraan Logo" 
    className='navbar-logo' // <-- Added navbar-logo class
  />
</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#home">Home</a>
        </li>
         <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#about">About</a>
        </li>
         <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#services">Services</a>
        </li>
         <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#contact">Contact</a>
        </li>
       
      </ul>
    </div>
  </div>
</nav>

{/* The navbar code ends here. */}

{/* The banner code starts here. */}
      <header id='home'>
<div className="container-fluid">
  
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={banner}class="d-block w-100 img-fluid" alt="..."/>
      <div class="carousel-caption d-none d-md-block content">
        <h5 className='banner-h5'>INNOVATE TRANSFORM NURTURE</h5>
        <p className='banner-p'>Empowering businesses with next-gen technology solutions.</p>
        <button className='more-btn'>More</button>
      </div>
    </div>

   
    
  </div>
 
</div>
      </header>
      {/* The banner code ends here. */}
      <main>
        {/* The about section code starts here. */}
        <section id='about'>
<div className="container-fluid border my-5">
   <div className="container">
      <h2 className='text-center mt-5 heading-h2'>About Us</h2>
      <div className="row my-4">
        <div className="col-lg-6">
          <img src={aboutus} alt="" className='img-fluid d-block mx-auto my-auto'/>
        </div>
           <div className="col-lg-6 m-auto">
            <h4 className='sub-heading-h4 mt-4 m-md-0'>
               Who we are?
            </h4>
            <p className='mt-4' style={{ textAlign: 'justify' }}>
              <strong>itechNEMARAAN</strong> is a forward-thinking technology organization offering software services across multiple domains. Founded in 2018 as a one-person consulting business, it has now grown into a dynamic team of IT specialists dedicated to delivering cutting-edge solutions.
            </p>
            <p className='mt-2' style={{ textAlign: 'justify' }}>
At <strong>itechNEMARAAN</strong>, we don’t just build software—we engineer **intelligent, scalable, and future-ready solutions** that redefine industries. Whether it’s autonomous automation streamlining workflows, AI-driven insights fueling business growth, or next-gen application development, we transform technology into a **competitive advantage**.
            </p>
           </div>
      </div>


    </div>
</div>
        </section>
        {/* The about section code ends here. */}

        {/* The services section code starts here. */}
        <section id='services'>
  <div className="container-fluid services">
      <div className="container my-lg-5 py-5">
  <h2 className='text-center heading2-h2'>Our Services</h2>
            <div className="row mt-5">
              <div className="col-lg-4 mt-2">
                <div class="card mx-auto p-3 ">
  <img src={architecture} class="card-img-top img-fluid m-auto" alt="..."/>
  <div class="card-body text-center">
    <h5 class="card-title fw-bold">Architecture & Integration</h5>
    <p class="card-text">Design, integration, and implementation of cutting-edge technology solutions.</p>
  </div>
</div>
              </div>
              <div className="col-lg-4 mt-2">
                <div class="card mx-auto p-3">
  <img src={intelligence} class="card-img-top img-fluid m-auto" alt="..."/>
  <div class="card-body text-center">
    <h5 class="card-title fw-bold">Business Intelligence Solutions</h5>
    <p class="card-text">Data-driven insights to optimize decision-making and business growth.</p>
  </div>
</div>
              </div>
              <div className="col-lg-4 mt-2">
                <div class="card mx-auto p-3">
  <img src={automation} class="card-img-top img-fluid m-auto" alt="..."/>
  <div class="card-body text-center">
    <h5 class="card-title fw-bold">Business Process Automation</h5>
    <p class="card-text">Streamlining operations with AI-powered automation and digital workflows.</p>

  </div>
</div>
              </div>
            </div>
              <div className="row my-lg-4">
                <div className="col-lg-2"></div>
              <div className="col-lg-4 mt-2">
                <div class="card mx-auto p-3">
  <img src={legacy} class="card-img-top img-fluid m-auto" alt="..."/>
  <div class="card-body text-center">
    <h5 class="card-title fw-bold">Legacy Modernization</h5>
    <p class="card-text">Upgrading outdated systems for better efficiency, security, and performance.</p>
  </div>
</div>
              </div>
              <div className="col-lg-4 mt-2">
                <div class="card mx-auto p-3">
  <img src={mobile} class="card-img-top img-fluid m-auto" alt="..."/>
  <div class="card-body text-center">
    <h5 class="card-title fw-bold">Mobile & Web Applications</h5>
    <p class="card-text">Innovative app solutions tailored for seamless user experiences.</p>
  </div>
</div>
              </div>
               <div className="col-lg-2"></div>
          
            </div>
      </div>
   
   
   
       
    </div>
        </section>

         {/* The services section code ends here. */}

          {/* The contact section code starts here. */}
        <section id='contact'>
    <div className="container-fluid border">
      <div className="container p-lg-5">
    <h2 className='text-center mt-5 heading-h2'>Contact Us</h2>
      <div className="row">
        <div className='col-lg-6 col-sm-12'>
          <form action="" className='m-auto contact-form' onSubmit={handleSubmit} noValidate>
            <div>
 <label htmlFor="" className='my-3'>Name</label><br/>
            <input type="text" required name='name' value={formData.name} onChange={handleChange} className='form-control'/>
                   {errors.name && (
                    <span className="text-danger">{errors.name}</span>
                  )}
            </div>
            <div>
 <label htmlFor="" className='my-3'>E-mail</label><br/>
            <input type="email" required name='email' value={formData.email} onChange={handleChange} className='form-control'/>
                {errors.email && (
                    <span className="text-danger">{errors.email}</span>
                  )}
            </div>
            <div>
  <label htmlFor="" className='my-3'>Message</label><br/>
         <textarea name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control"></textarea>
                       {errors.message && (
                    <span className="text-danger">{errors.message}</span>
                  )}
            </div>
            <button
  className="more-btn mt-3"
  type="submit"
  disabled={loading}
>
  {loading ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Submitting...
    </>
  ) : (
    "Submit"
  )}
</button>
      
           
              
             
          </form>

        </div>
        <div className='col-lg-6 col-sm-12 my-4 m-md-0'>
          <img src={contact} alt="" className='img-fluid d-block m-auto'/>
        </div>
      </div>
      </div>
    
    </div>
        </section>

         {/* The contact section code ends here. */}
      </main>
 


 
   {/* The footer section code starts here. */}

    <footer>
   <div className="container-fluid">
        <div className="grey">
          <div className="container">
            <div className="row py-2">
  <div className="col-6">
          <p className='mb-0 fw-bold'>Follow us</p>
          </div>
          <div className="col-6">
            <div className='social-icons'>
              <div className='facebook-icon'>
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
</svg>
              </div>
              <div className='twitter-icon'>
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
  <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
</svg>
              </div>
              <div className='linkedin-icon'>
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
</svg>
              </div>
              <div className='whatsapp-icon'>
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
</svg>
              </div>




            </div>

          </div>
            </div>
          </div>
        

        </div>
        <div className="">
          <div className="container">
            <div className="row py-4 mt-3">
  <div className="col-lg-4 col-sm-12">
            <img src={logo} alt="" className='navbar-logo'/>
            <p className='mt-3'>
              itechNEMARAAN is a forward-thinking technology organization offering software services across multiple domains.
            </p>

          </div>
          <div className="col-lg-4 col-sm-12">
            <h4>Services</h4>
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
</svg>Architecture & Integration
            </p>
                <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
</svg>Business Intelligence Solutions
            </p>
                <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
</svg>Business Intelligence Solutions
            </p>
                <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
</svg>Legacy Modernization
            </p>

          </div>
          <div className="col-lg-4 col-sm-12 contact-info">
    <h4>Contact us</h4>
    <a href="tel:+919840037647">
<p>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-fill me-1" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
</svg>
+91 98400 37647
</p>
    </a>

    <a href="mailto:info@itechnemaraan.com">
<p>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-at-fill me-1" viewBox="0 0 16 16">
  <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671"/>
  <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791"/>
</svg>
info@itechnemaraan.com
</p>
    </a>
    <a href="#">
      <p className='mt-4 fw-bold'>
        Office Address:
      </p>
    </a>
    <a > {/* Optionally add a map link href="https://maps.app.goo.gl/YourNewMapLink" target="_blank" */}
      <p>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill me-1" viewBox="0 0 16 16">
          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
        </svg>
        No. 2, First floor, New No.9, 4th street, Venkateswara Nagar, Adyar, Chennai-600020
      </p>
    </a>

    {/* 2. Co Working Address (The Existing Address) */}
    <a href="#">
      {/*
      <p className='mt-4 fw-bold'>
        Co Working Address:
      </p>
      */}
    </a>
    <a >
      <p>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill me-1" viewBox="0 0 16 16">
          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
        </svg>
        SKCL Tech Square, 2 nd Floor, 14, South Phase, SIDCO Industrial Estate, Guindy, Chennai-600032
      </p>
    </a>



          </div>
            </div>

          </div>
        

        </div>
        <div className="green">
          <div className="container">
 <div className="col-12 py-1">
          <p className='text-center py-1'>© 2025 itechNEMARAAN. All Rights Reserved.</p>
          </div>
          </div>
         

        </div>
     
    </div>
    </footer>
     {/* The footer section code ends here. */}
 

    </div>
  )
}
